import React from 'react'
import { useForm } from 'react-hook-form'
import {
  Header,
  Loader,
  Button,
  Label,
  Checkbox,
  Text,
  Stack,
} from '@crossfit/ui'

import * as formsService from 'services/forms'
import { useQueryClient } from 'react-query'
import style from './style.module.css'
import { useSelector } from 'react-redux'
import { getUser } from 'store/selectors'
import { User } from 'types'

type FormInput = {
  agreeToTos: boolean
}

function useTermsOfServiceForm() {
  const queryClient = useQueryClient()
  const user = useSelector(getUser) as User
  const form = useForm<FormInput>()

  async function onSubmit({ agreeToTos }: FormInput) {
    const { firstName, lastName, email } = user

    await formsService.submitAPNTermsOfService({
      name: `${firstName} ${lastName}`,
      email,
      agreeToTos,
    })
    await queryClient.refetchQueries('agreement')
  }

  return {
    ...form,
    isSubmitting: form.formState.isSubmitting,
    onSubmit: form.handleSubmit(onSubmit),
    isSubmitSuccessful: form.formState.isSubmitSuccessful,
  }
}

function TermsOfService() {
  const { onSubmit, register, watch, isSubmitting } = useTermsOfServiceForm()

  return (
    <div className={style.wrapper}>
      <Header size='large' as='h2' mb={3}>
        Welcome!
      </Header>

      <Text mb={8}>
        To start browsing the Affiliate Toolkit, please accept the terms of
        service below.
      </Text>

      <form onSubmit={onSubmit}>
        <Stack direction='horizontal' mb={8} spacing={2}>
          <Checkbox
            id='agreeToTos'
            type='checkbox'
            required
            {...register('agreeToTos')}
          />

          <Label htmlFor='agreeToTos' className={style.label}>
            I have read and agree to CrossFit’s{' '}
            <a
              className={style.link}
              href='https://www.crossfit.com/affiliate-toolkit-terms-of-service/'
              target='_blank'
              rel='noreferrer'
            >
              terms of service
            </a>
            .
          </Label>
        </Stack>

        {isSubmitting ? (
          <Loader />
        ) : (
          <Button type='submit' disabled={!watch('agreeToTos')}>
            Access Toolkit Content
          </Button>
        )}
      </form>
    </div>
  )
}

export default TermsOfService
